module.exports = __webpack_public_path__ + "img/tree1_2021_mall.5e245d70.gif";